<script setup lang="ts">
import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetHeader,
    SheetTitle,
} from '@/components/ui/sheet';
import NotificationFeed from '@/components/notifications/NotificationFeed.vue';
import type { NotificationSurface } from '~/types/models';

const props = defineProps<{
    open: boolean;
    surface: NotificationSurface;
    tenantId?: string | null;
    clientId?: string | null;
}>();

const emit = defineEmits<{
    (e: 'update:open', value: boolean): void;
}>();

const drawerTitle = computed(() => props.surface === 'tenant' ? 'Workspace Notifications' : 'Portal Notifications');
const drawerDescription = computed(() => props.surface === 'tenant'
    ? 'Important updates that deserve attention without turning the app into noise.'
    : 'Important client-side updates from messages, approvals, tasks, and billing.'
);

async function handleNotificationSelect(notification: { actionPath?: string | null }) {
    if (!notification.actionPath) {
        return;
    }

    emit('update:open', false);
    await navigateTo(notification.actionPath);
}
</script>

<template>
    <Sheet :open="open" @update:open="emit('update:open', $event)">
        <SheetContent side="right" class="w-full max-w-xl gap-0 overflow-hidden p-0 sm:max-w-xl">
            <SheetHeader class="border-b border-border/70 px-6 py-5 text-left">
                <SheetTitle>{{ drawerTitle }}</SheetTitle>
                <SheetDescription>{{ drawerDescription }}</SheetDescription>
            </SheetHeader>

            <div class="flex-1 overflow-y-auto px-4 py-4">
                <NotificationFeed
                    :surface="surface"
                    :tenant-id="tenantId"
                    :client-id="clientId"
                    :show-header="false"
                    @select="handleNotificationSelect"
                />
            </div>
        </SheetContent>
    </Sheet>
</template>
